var _g, _path, _path2, _g2, _path3, _path4, _path5, _path6, _path7, _g3, _g4, _g5, _g6, _g7, _g8, _path8, _g9, _g10, _path9, _g11, _g12, _path10, _g13, _g14, _g15, _g16, _path11, _g17, _g18, _g19, _path12, _g20, _path13, _path14, _path15, _g21, _g22, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _g23, _path44, _path45, _path46, _g24, _path47, _g25, _path48, _path49, _g26, _path50, _g27, _path51, _g28, _g29;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBtnTop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.025,
    height: 83.483,
    viewBox: "0 0 54.025 83.483",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_38627",
    "data-name": "\\uADF8\\uB8F9 38627",
    transform: "translate(-1826.997 -796.629)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1",
    "data-name": "\\uADF8\\uB8F9 1",
    transform: "translate(30.333 22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "top",
    transform: "translate(1806.667 856)",
    fill: "#212c92"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 15.76000118255615 1.112000107765198 C 14.5364408493042 1.112000107765198 13.39554119110107 0.8217801451683044 12.36901092529297 0.2494101375341415 C 11.33561134338379 -0.3267898559570312 10.50422096252441 -1.141879916191101 9.897931098937988 -2.17320990562439 C 9.291491508483887 -3.204789876937866 8.984001159667969 -4.373879909515381 8.984001159667969 -5.64799976348877 C 8.984001159667969 -6.496282577514648 9.120287895202637 -7.296780109405518 9.390362739562988 -8.039999961853027 L 9.072001457214355 -8.039999961853027 L 7.096001148223877 -8.039999961853027 L 7.096001148223877 1.335144048653092e-07 L 7.096001148223877 1.00000011920929 L 6.096001148223877 1.00000011920929 L 3.360001087188721 1.00000011920929 L 2.360001087188721 1.00000011920929 L 2.360001087188721 1.335144048653092e-07 L 2.360001087188721 -8.039999961853027 L 0.3840011656284332 -8.039999961853027 L -0.6159988641738892 -8.039999961853027 L -0.6159988641738892 -9.039999961853027 L -0.6159988641738892 -11.23199939727783 L -0.6159988641738892 -12.23199939727783 L 0.3840011656284332 -12.23199939727783 L 9.072001457214355 -12.23199939727783 L 10.07200145721436 -12.23199939727783 L 10.07200145721436 -11.23199939727783 L 10.07200145721436 -9.394100189208984 C 10.65985012054443 -10.28914451599121 11.43129062652588 -11.00655651092529 12.36901092529297 -11.52940940856934 C 13.39554119110107 -12.10177993774414 14.5364408493042 -12.39200019836426 15.76000118255615 -12.39200019836426 C 16.98356056213379 -12.39200019836426 18.12446022033691 -12.10177993774414 19.15099143981934 -11.52940940856934 C 20.18638038635254 -10.95209980010986 21.01347160339355 -10.13784027099609 21.60931205749512 -9.109250068664551 C 21.7686710357666 -8.834133148193359 21.9069766998291 -8.548871040344238 22.02400207519531 -8.254258155822754 L 22.02400207519531 -11.23199939727783 L 22.02400207519531 -12.23199939727783 L 23.02400207519531 -12.23199939727783 L 27.45600128173828 -12.23199939727783 C 28.50444030761719 -12.23199939727783 29.41932106018066 -12.04036998748779 30.17521095275879 -11.66242980957031 C 30.97137069702148 -11.26435947418213 31.58172035217285 -10.6990795135498 31.98929023742676 -9.9822998046875 C 32.3839111328125 -9.288310050964355 32.58399963378906 -8.492170333862305 32.58399963378906 -7.615999698638916 C 32.58399963378906 -6.796720027923584 32.39107131958008 -6.033349990844727 32.01056289672852 -5.347089767456055 C 31.61840057373047 -4.639780044555664 31.01979064941406 -4.067470073699951 30.23138046264648 -3.646069765090942 C 29.46903038024902 -3.23859977722168 28.53525161743164 -3.031999826431274 27.45600128173828 -3.031999826431274 L 26.76000022888184 -3.031999826431274 L 26.76000022888184 1.335144048653092e-07 L 26.76000022888184 1.00000011920929 L 25.76000022888184 1.00000011920929 L 23.02400207519531 1.00000011920929 L 22.02400207519531 1.00000011920929 L 22.02400207519531 1.335144048653092e-07 L 22.02400207519531 -3.048214435577393 C 21.90478515625 -2.748136281967163 21.76350402832031 -2.457527875900269 21.60035133361816 -2.177109956741333 C 20.99971199035645 -1.144759893417358 20.1737003326416 -0.3287898600101471 19.14525032043457 0.2481401264667511 C 18.12344169616699 0.8213601112365723 16.98448181152344 1.112000107765198 15.76000118255615 1.112000107765198 Z M 15.76000118255615 -7.911999702453613 C 15.13193130493164 -7.911999702453613 14.67710113525391 -7.735219955444336 14.32860088348389 -7.355669975280762 C 13.9621410369873 -6.956559658050537 13.78400135040283 -6.397969722747803 13.78400135040283 -5.64799976348877 C 13.78400135040283 -4.907049655914307 13.96313095092773 -4.349989891052246 14.33164119720459 -3.94500994682312 C 14.67990112304688 -3.562259912490845 15.13377094268799 -3.383999824523926 15.76000118255615 -3.383999824523926 C 16.37349128723145 -3.383999824523926 16.82133102416992 -3.563759803771973 17.16937065124512 -3.949699878692627 C 17.53989028930664 -4.360569953918457 17.72000122070312 -4.91609001159668 17.72000122070312 -5.64799976348877 C 17.72000122070312 -6.388949871063232 17.54087066650391 -6.946009635925293 17.17236137390137 -7.350989818572998 C 16.82410049438477 -7.733739852905273 16.37531089782715 -7.911999702453613 15.76000118255615 -7.911999702453613 Z M 26.76000022888184 -7.207999706268311 L 27.24800109863281 -7.207999706268311 C 27.55031204223633 -7.207999706268311 27.69162178039551 -7.266870021820068 27.72410202026367 -7.297989845275879 C 27.79014205932617 -7.361279964447021 27.80000114440918 -7.524399757385254 27.80000114440918 -7.615999698638916 C 27.80000114440918 -7.707599639892578 27.79014205932617 -7.870719909667969 27.72410202026367 -7.934010028839111 C 27.69162178039551 -7.965129852294922 27.55031204223633 -8.02400016784668 27.24800109863281 -8.02400016784668 L 26.76000022888184 -8.02400016784668 L 26.76000022888184 -7.207999706268311 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 15.76000022888184 -11.39200019836426 C 14.70400047302246 -11.39200019836426 13.73600196838379 -11.14666938781738 12.85600090026855 -10.6560001373291 C 11.97600173950195 -10.1653299331665 11.27733039855957 -9.482669830322266 10.76000022888184 -8.607999801635742 C 10.24267196655273 -7.733329772949219 9.984001159667969 -6.746669769287109 9.984001159667969 -5.64799976348877 C 9.984001159667969 -4.54932975769043 10.24267196655273 -3.559999942779541 10.76000022888184 -2.680000305175781 C 11.27733039855957 -1.800000190734863 11.97600173950195 -1.114669799804688 12.85600090026855 -0.6239995956420898 C 13.73600196838379 -0.1333293914794922 14.70400047302246 0.1120004653930664 15.76000022888184 0.1120004653930664 C 16.81600189208984 0.1120004653930664 17.78133010864258 -0.1333293914794922 18.65600204467773 -0.6239995956420898 C 19.53067016601562 -1.114669799804688 20.22400093078613 -1.800000190734863 20.73600006103516 -2.680000305175781 C 21.24800109863281 -3.559999942779541 21.50400161743164 -4.54932975769043 21.50400161743164 -5.64799976348877 C 21.50400161743164 -6.746669769287109 21.25065994262695 -7.733329772949219 20.7440013885498 -8.607999801635742 C 20.23733139038086 -9.482669830322266 19.54400253295898 -10.1653299331665 18.66400146484375 -10.6560001373291 C 17.78400039672852 -11.14666938781738 16.81600189208984 -11.39200019836426 15.76000022888184 -11.39200019836426 M 15.76000022888184 -2.383999824523926 C 14.85333061218262 -2.383999824523926 14.13067054748535 -2.680000305175781 13.59200096130371 -3.272000312805176 C 13.05333137512207 -3.863999843597412 12.78400039672852 -4.655999660491943 12.78400039672852 -5.64799976348877 C 12.78400039672852 -6.650670051574707 13.05333137512207 -7.445329666137695 13.59200096130371 -8.031999588012695 C 14.13067054748535 -8.618669509887695 14.85333061218262 -8.911999702453613 15.76000022888184 -8.911999702453613 C 16.65600204467773 -8.911999702453613 17.37333106994629 -8.616000175476074 17.91200256347656 -8.02400016784668 C 18.4506721496582 -7.432000160217285 18.72000122070312 -6.639999866485596 18.72000122070312 -5.64799976348877 C 18.72000122070312 -4.666669845581055 18.4506721496582 -3.87732982635498 17.91200256347656 -3.279999732971191 C 17.37333106994629 -2.682669639587402 16.65600204467773 -2.383999824523926 15.76000022888184 -2.383999824523926 M 0.3840007781982422 -11.23199939727783 L 0.3840007781982422 -9.039999961853027 L 3.360000610351562 -9.039999961853027 L 3.360000610351562 0 L 6.096000671386719 0 L 6.096000671386719 -9.039999961853027 L 9.072000503540039 -9.039999961853027 L 9.072000503540039 -11.23199939727783 L 0.3840007781982422 -11.23199939727783 M 23.02400207519531 -11.23199939727783 L 23.02400207519531 0 L 25.76000213623047 0 L 25.76000213623047 -4.032000064849854 L 27.45600128173828 -4.032000064849854 C 28.37333106994629 -4.032000064849854 29.14133071899414 -4.197329998016357 29.76000213623047 -4.527999877929688 C 30.37867164611816 -4.858669757843018 30.83733177185059 -5.29332971572876 31.13600158691406 -5.831999778747559 C 31.43467140197754 -6.370669841766357 31.5840015411377 -6.965329647064209 31.5840015411377 -7.616000175476074 C 31.5840015411377 -8.319999694824219 31.42933082580566 -8.944000244140625 31.1200008392334 -9.48799991607666 C 30.81067085266113 -10.0319995880127 30.34667205810547 -10.45866966247559 29.72800064086914 -10.76799964904785 C 29.10933113098145 -11.07732963562012 28.35200119018555 -11.23199939727783 27.45600128173828 -11.23199939727783 L 23.02400207519531 -11.23199939727783 M 27.24800109863281 -6.207999706268311 L 25.76000213623047 -6.207999706268311 L 25.76000213623047 -9.02400016784668 L 27.24800109863281 -9.02400016784668 C 27.77067184448242 -9.02400016784668 28.16000175476074 -8.90132999420166 28.41600036621094 -8.656000137329102 C 28.67200088500977 -8.410669326782227 28.80000114440918 -8.064000129699707 28.80000114440918 -7.616000175476074 C 28.80000114440918 -7.167999744415283 28.67200088500977 -6.821330070495605 28.41600036621094 -6.575999736785889 C 28.16000175476074 -6.33066987991333 27.77067184448242 -6.207999706268311 27.24800109863281 -6.207999706268311 M 15.76000022888184 -13.39200019836426 C 17.15605163574219 -13.39200019836426 18.46080017089844 -13.05918979644775 19.63799095153809 -12.40281009674072 C 20.14375877380371 -12.12080478668213 20.60642433166504 -11.78985404968262 21.02400207519531 -11.41192054748535 L 21.02400207519531 -13.23200035095215 L 27.45600128173828 -13.23200035095215 C 28.66109085083008 -13.23200035095215 29.72642135620117 -13.00485038757324 30.62242126464844 -12.55685997009277 C 31.59896087646484 -12.06859016418457 32.35132217407227 -11.36868953704834 32.85858154296875 -10.47659969329834 C 33.33994293212891 -9.630069732666016 33.58399963378906 -8.667630195617676 33.58399963378906 -7.616000175476074 C 33.58399963378906 -6.62507963180542 33.34886932373047 -5.698559761047363 32.8851318359375 -4.862179756164551 C 32.39802932739258 -3.983669757843018 31.66378021240234 -3.277790069580078 30.70276069641113 -2.764140129089355 C 29.86854934692383 -2.318270683288574 28.87977409362793 -2.07412052154541 27.76000213623047 -2.036989212036133 L 27.76000213623047 2 L 21.02400207519531 2 L 21.02400207519531 0.1196107864379883 C 20.6048698425293 0.5019207000732422 20.14106178283691 0.8361148834228516 19.63450241088867 1.120280265808105 C 18.46145248413086 1.778340339660645 17.15788078308105 2.112000465393066 15.76000022888184 2.112000465393066 C 14.36395072937012 2.112000465393066 13.05920028686523 1.779190063476562 11.88201141357422 1.122810363769531 C 10.69113159179688 0.4588003158569336 9.733541488647461 -0.479640007019043 9.035861968994141 -1.666419982910156 C 8.564916610717773 -2.467522621154785 8.250635147094727 -3.337863445281982 8.096000671386719 -4.266237735748291 L 8.096000671386719 2 L 1.360000610351562 2 L 1.360000610351562 -7.039999961853027 L -1.615997314453125 -7.039999961853027 L -1.615997314453125 -13.23200035095215 L 11.07200050354004 -13.23200035095215 L 11.07200050354004 -11.88307285308838 C 11.32854652404785 -12.07145404815674 11.59871292114258 -12.24484825134277 11.88201141357422 -12.40281009674072 C 13.05920028686523 -13.05918979644775 14.36395072937012 -13.39200019836426 15.76000022888184 -13.39200019836426 Z M 15.76000022888184 -4.383999824523926 C 16.17934036254883 -4.383999824523926 16.32403182983398 -4.505509853363037 16.42674255371094 -4.619400024414062 C 16.49927139282227 -4.699830055236816 16.72000122070312 -4.944599628448486 16.72000122070312 -5.64799976348877 C 16.72000122070312 -6.362269878387451 16.50378036499023 -6.599899768829346 16.43273162841797 -6.677989959716797 C 16.3297119140625 -6.791209697723389 16.18426132202148 -6.911999702453613 15.76000022888184 -6.911999702453613 C 15.27882194519043 -6.911999702453613 15.13985061645508 -6.760649681091309 15.06520080566406 -6.67933988571167 C 14.87861061096191 -6.476119995117188 14.78400039672852 -6.129129886627197 14.78400039672852 -5.64799976348877 C 14.78400039672852 -4.933729648590088 15.00022125244141 -4.696099758148193 15.0712718963623 -4.6180100440979 C 15.14569091796875 -4.536230087280273 15.28421211242676 -4.383999824523926 15.76000022888184 -4.383999824523926 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-arrow-down",
    "data-name": "Icon ionic-ios-arrow-down",
    transform: "translate(1813.479 823.324)",
    fill: "#212c92"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 12.99799823760986 16.43877983093262 C 12.59598827362061 16.43877983093262 12.20278835296631 16.27536010742188 11.91919803619385 15.99041080474854 L 9.854499816894531 13.92422199249268 L 7.786888122558594 15.99038028717041 C 7.498513221740723 16.27797508239746 7.116289615631104 16.43600082397461 6.71003532409668 16.43600082397461 C 6.709985733032227 16.43600082397461 6.710007667541504 16.43600082397461 6.709958076477051 16.43600082397461 C 6.302117824554443 16.43597984313965 5.91890811920166 16.27694129943848 5.630918025970459 15.98818016052246 C 5.34345817565918 15.69994068145752 5.185448169708252 15.31700038909912 5.186007976531982 14.90992069244385 C 5.186568260192871 14.50281047821045 5.345638275146484 14.12030029296875 5.633927822113037 13.83285999298096 L 8.797787666320801 10.67700004577637 L 8.812487602233887 10.66234016418457 L 8.827788352966309 10.64830017089844 C 9.109508514404297 10.38971042633057 9.475237846374512 10.24730014801025 9.857598304748535 10.24730014801025 C 10.26370811462402 10.24730014801025 10.6456880569458 10.40522003173828 10.93319797515869 10.69198036193848 L 14.07532787322998 13.83612060546875 L 14.07743835449219 13.83823013305664 L 14.07953834533691 13.84035015106201 C 14.66414833068848 14.43236064910889 14.66414833068848 15.39564037322998 14.07953834533691 15.98764991760254 C 13.79325771331787 16.27534103393555 13.40003776550293 16.43877983093262 12.99799823760986 16.43877983093262 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 9.857601165771484 11.24729633331299 C 9.730986595153809 11.24729633331299 9.604223251342773 11.29300403594971 9.503997802734375 11.38500022888184 L 6.339998245239258 14.54100036621094 C 6.135067939758301 14.74533081054688 6.134617805480957 15.07711029052734 6.338977813720703 15.28202056884766 C 6.543337821960449 15.48692989349365 6.87510871887207 15.48738193511963 7.08002758026123 15.28302001953125 L 9.854997634887695 12.51000022888184 L 12.62799835205078 15.28500080108643 C 12.72596740722656 15.3834400177002 12.85911750793457 15.43878078460693 12.99799823760986 15.43878078460693 C 13.13687801361084 15.43878078460693 13.27003860473633 15.3834400177002 13.36799812316895 15.28500080108643 C 13.57107734680176 15.07935047149658 13.57107734680176 14.74865055084229 13.36799812316895 14.54300022125244 L 10.2269983291626 11.40000057220459 C 10.12516021728516 11.29842472076416 9.99146556854248 11.24729633331299 9.857601165771484 11.24729633331299 M 9.857598304748535 9.24730110168457 C 10.53033828735352 9.24730110168457 11.16312789916992 9.508920669555664 11.63939762115479 9.983980178833008 L 14.79107856750488 13.13771057128906 C 15.75828838348389 14.11716079711914 15.75828838348389 15.71084022521973 14.79107856750488 16.6902904510498 L 14.78566741943359 16.69575119018555 C 14.31575775146484 17.16796112060547 13.66418838500977 17.43878173828125 12.99799823760986 17.43878173828125 C 12.33185768127441 17.43878173828125 11.68030834197998 17.1679801940918 11.21040821075439 16.69583129882812 L 9.853995323181152 15.33843898773193 L 8.493747711181641 16.69773101806641 C 8.015917778015137 17.17430114746094 7.382927894592285 17.43600082397461 6.710007667541504 17.43600082397461 C 6.034518241882324 17.43600082397461 5.399818420410156 17.1725902557373 4.92283821105957 16.69430160522461 C 4.446767807006836 16.21696090698242 4.185077667236328 15.58275032043457 4.186008453369141 14.90855026245117 C 4.186927795410156 14.23430061340332 4.450387954711914 13.60078048706055 4.927858352661133 13.12471008300781 L 8.151568412780762 9.911590576171875 C 8.618268013000488 9.483221054077148 9.224147796630859 9.24730110168457 9.857598304748535 9.24730110168457 Z",
    stroke: "none",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1-2",
    "data-name": "\\uADF8\\uB8F9 1",
    transform: "translate(3189.329 1143.965)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1",
    "data-name": "\\uD328\\uC2A4 1",
    d: "M-1311.886-309.887a24.223,24.223,0,0,1-22.986,25.4,24.225,24.225,0,0,1-25.4-22.986,24.227,24.227,0,0,1,22.987-25.4,24.227,24.227,0,0,1,25.4,22.989",
    transform: "translate(-1.496 -10.647)",
    fill: "#f4e487"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2",
    "data-name": "\\uD328\\uC2A4 2",
    d: "M-1265.542-300.07s2.441-10.575-2.776-20.3l-9.094,2.265s6.3,4.63,7.919,17.972c0,0,2.367,4.535,3.952.062",
    transform: "translate(-62.658 -19.898)",
    fill: "#ffc428"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_3",
    "data-name": "\\uADF8\\uB8F9 3",
    transform: "translate(-1332.386 -340.267)",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2",
    "data-name": "\\uADF8\\uB8F9 2",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1-3",
    "data-name": "\\uADF8\\uB8F9 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3",
    "data-name": "\\uD328\\uC2A4 3",
    d: "M-1246.689-320.369l-1.41.4c3.785,6.365,4.172,15.655,4.03,20.306.051-.126.1-.261.156-.406,0,0,2.442-10.574-2.776-20.3",
    transform: "translate(1248.099 320.369)",
    fill: "#1a1311"
  }))))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4",
    "data-name": "\\uD328\\uC2A4 4",
    d: "M-1330.084-254.3l8.619.115c12.594,2.924,13.157-6.309,13.157-6.309-.458.236-1.018.723-2.822-.82a5.967,5.967,0,0,0-2.607-1.592c2.537-1.4,3.263-5.448,3.263-5.448-3.052,3.23-5.209-2.43-10.663-2.616-2.741-.1-5.088,2.344-5.088,2.344s-.979-1.535-4.066-1.4a6.2,6.2,0,0,0-4.511,1.952,11.851,11.851,0,0,0-8.764-2.61c-6.482.456-9.942,7.962-15.041,4.968,0,0,2.129,4.646,5.116,5.083a6.274,6.274,0,0,0-2.762,1.652c-1.2,1.27-2.545,3.639-6.08,2.006,0,0,6.167,12.9,23.751,5.555Z",
    transform: "translate(0 -56.343)",
    fill: "#9c5706"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_5",
    "data-name": "\\uD328\\uC2A4 5",
    d: "M-1216.942-256.5a3.342,3.342,0,0,1,2.478-3.386,3.432,3.432,0,0,1,.68-.1,3.308,3.308,0,0,1,2.4.856,3.311,3.311,0,0,1,1.091,2.3,3.34,3.34,0,0,1-2.479,3.384h0a3.388,3.388,0,0,1-.677.105,3.316,3.316,0,0,1-2.4-.856,3.311,3.311,0,0,1-1.09-2.3",
    transform: "translate(-107.274 -64.446)",
    fill: "#1a1311"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_6",
    "data-name": "\\uD328\\uC2A4 6",
    d: "M-1209.186-253.764a1.15,1.15,0,0,1-1.092,1.2,1.149,1.149,0,0,1-1.2-1.09,1.152,1.152,0,0,1,1.09-1.206,1.152,1.152,0,0,1,1.207,1.091",
    transform: "translate(-111.304 -68.237)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_7",
    "data-name": "\\uD328\\uC2A4 7",
    d: "M-1301.419-253.209a4.028,4.028,0,0,1,2.989-4.084,3.884,3.884,0,0,1,.82-.126,3.977,3.977,0,0,1,2.893,1.032,3.981,3.981,0,0,1,1.316,2.777,4.026,4.026,0,0,1-2.991,4.083,3.854,3.854,0,0,1-.819.126,3.984,3.984,0,0,1-2.894-1.032,3.987,3.987,0,0,1-1.316-2.778",
    transform: "translate(-44.941 -66.343)",
    fill: "#1a1311"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_8",
    "data-name": "\\uD328\\uC2A4 8",
    d: "M-1291.849-248.827a1.246,1.246,0,0,1-1.182,1.308,1.245,1.245,0,0,1-1.309-1.184,1.245,1.245,0,0,1,1.182-1.306,1.245,1.245,0,0,1,1.308,1.181",
    transform: "translate(-50.167 -71.813)",
    fill: "#fff"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_6",
    "data-name": "\\uADF8\\uB8F9 6",
    transform: "translate(-1354.16 -306.923)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_5",
    "data-name": "\\uADF8\\uB8F9 5",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_4",
    "data-name": "\\uADF8\\uB8F9 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_9",
    "data-name": "\\uD328\\uC2A4 9",
    d: "M-1331.158-190.05s7.3,7.477,17.458,3.006c0,0,7.281,2.265,13.738.223l-9.189-4.568-11.2-1.782Z",
    transform: "translate(1331.158 193.171)",
    fill: "#9c5706"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_9",
    "data-name": "\\uADF8\\uB8F9 9",
    transform: "translate(-1353.566 -319.146)",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8",
    "data-name": "\\uADF8\\uB8F9 8",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_7",
    "data-name": "\\uADF8\\uB8F9 7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10",
    "data-name": "\\uD328\\uC2A4 10",
    d: "M-1309.09-239.8s-4.229,1.215-6.428,4.4c0,0-6.218-1.478-13.375,8.01l15.374-4.083Z",
    transform: "translate(1328.893 239.797)",
    fill: "#1a1311"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_12",
    "data-name": "\\uADF8\\uB8F9 12",
    transform: "translate(-1326.249 -326.867)",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_11",
    "data-name": "\\uADF8\\uB8F9 11",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_10",
    "data-name": "\\uADF8\\uB8F9 10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11",
    "data-name": "\\uD328\\uC2A4 11",
    d: "M-1218.485-269.16a5.919,5.919,0,0,0-6.045,2.755l-.154,1.509s2.638-4.177,6.2-4.263",
    transform: "translate(1224.685 269.252)",
    fill: "#1a1311"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_15",
    "data-name": "\\uADF8\\uB8F9 15",
    transform: "translate(-1342.144 -326.609)",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_14",
    "data-name": "\\uADF8\\uB8F9 14",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_13",
    "data-name": "\\uADF8\\uB8F9 13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12",
    "data-name": "\\uD328\\uC2A4 12",
    d: "M-1277.666-263.718l-.337-1.675a10.242,10.242,0,0,0-7.319-2.875s6.179,1.6,7.655,4.549",
    transform: "translate(1285.321 268.268)",
    fill: "#1a1311"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_18",
    "data-name": "\\uADF8\\uB8F9 18",
    transform: "translate(-1313.793 -324.165)",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_17",
    "data-name": "\\uADF8\\uB8F9 17",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_16",
    "data-name": "\\uADF8\\uB8F9 16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_13",
    "data-name": "\\uD328\\uC2A4 13",
    d: "M-1175.848-258.3a1.866,1.866,0,0,0,1.647-.649s-.72,3.364-2.969,4.778c0,0,1.856-2.528,1.322-4.129",
    transform: "translate(1177.17 258.944)",
    fill: "#1a1311"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21",
    "data-name": "\\uADF8\\uB8F9 21",
    transform: "translate(-1323.874 -318.357)",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_20",
    "data-name": "\\uADF8\\uB8F9 20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_19",
    "data-name": "\\uADF8\\uB8F9 19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_14",
    "data-name": "\\uD328\\uC2A4 14",
    d: "M-1202.958-235.686s.411,3-1.236,3.372c-5.228-.057-11.433-4.476-11.433-4.476,1.329,3.748,6.965,6.172,8.982,6.932a5.352,5.352,0,0,1-2.411-.089c-3.7-.917,2.54.85,2.54.85a6.873,6.873,0,0,0,6.021-5.406s-1.065.419-2.463-1.184",
    transform: "translate(1215.627 236.79)",
    fill: "#1a1311"
  }))))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_15",
    "data-name": "\\uD328\\uC2A4 15",
    d: "M-1326.061-215.78a8.2,8.2,0,0,0-9.177.686c-4.751,3.55-6.024,5.5-10.339,4.387,0,0,12.384,13.41,23.231,2.323Z",
    transform: "translate(-12.363 -96.265)",
    fill: "#ffc72b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_24",
    "data-name": "\\uADF8\\uB8F9 24",
    transform: "translate(-1343.602 -310.357)",
    opacity: 0.25,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_23",
    "data-name": "\\uADF8\\uB8F9 23",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_22",
    "data-name": "\\uADF8\\uB8F9 22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_16",
    "data-name": "\\uD328\\uC2A4 16",
    d: "M-1289.553-206.271s-1.506,4.742,2.1,6.927c0,0-6.03-2.283-2.1-6.927",
    transform: "translate(1290.883 206.271)",
    fill: "#1a1311"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_27",
    "data-name": "\\uADF8\\uB8F9 27",
    transform: "translate(-1347.503 -309.128)",
    opacity: 0.25,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_26",
    "data-name": "\\uADF8\\uB8F9 26",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_25",
    "data-name": "\\uADF8\\uB8F9 25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_17",
    "data-name": "\\uD328\\uC2A4 17",
    d: "M-1304.63-201.583s-1.285,4.045,1.791,5.91c0,0-5.142-1.95-1.791-5.91",
    transform: "translate(1305.765 201.583)",
    fill: "#1a1311"
  }))))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_18",
    "data-name": "\\uD328\\uC2A4 18",
    d: "M-1221.659-215.758a15.7,15.7,0,0,1,5.358-.787c3.885-.04,6.23,4.1,9.06,2.384,0,0-3.567,11.845-16.656,6.142,0,0-1.5-7.738,2.239-7.739",
    transform: "translate(-101.926 -96.505)",
    fill: "#ffc72b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_30",
    "data-name": "\\uADF8\\uB8F9 30",
    transform: "translate(-1318.54 -310.172)",
    opacity: 0.25,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_29",
    "data-name": "\\uADF8\\uB8F9 29",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_28",
    "data-name": "\\uADF8\\uB8F9 28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_19",
    "data-name": "\\uD328\\uC2A4 19",
    d: "M-1194.885-205.564s1.869,3.243-.395,5.312c0,0,4.009-2.464.395-5.312",
    transform: "translate(1195.28 205.564)",
    fill: "#1a1311"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_33",
    "data-name": "\\uADF8\\uB8F9 33",
    transform: "translate(-1315.82 -310.158)",
    opacity: 0.25,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_32",
    "data-name": "\\uADF8\\uB8F9 32",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_31",
    "data-name": "\\uADF8\\uB8F9 31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_20",
    "data-name": "\\uD328\\uC2A4 20",
    d: "M-1184.572-205.512s1.557,2.7-.33,4.428c0,0,3.34-2.054.33-4.428",
    transform: "translate(1184.902 205.512)",
    fill: "#1a1311"
  }))))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_21",
    "data-name": "\\uD328\\uC2A4 21",
    d: "M-1269.492-242.21s6.434-1.734,9.739,1.361c1.382,1.561,6.825,4.5,8.345,4.532s-2.217,3.1-7.737,3.262c0,0-.235,3.639.935,5.711,2.624,4.649-.383,3.837-2,4.137s-13.536.915-16.086-9.427c-.991-4.623,4.862-9.262,6.8-9.575",
    transform: "translate(-63.4 -77.211)",
    fill: "#126abf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_36",
    "data-name": "\\uADF8\\uB8F9 36",
    transform: "translate(-1333.538 -312.971)",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_35",
    "data-name": "\\uADF8\\uB8F9 35",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_34",
    "data-name": "\\uADF8\\uB8F9 34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_22",
    "data-name": "\\uD328\\uC2A4 22",
    d: "M-1251.1-215.423s.542,5.592,2.387,7.781,5.166,2.714,7.024,2.947c0,0-6.146.368-8.565-3.615a19.316,19.316,0,0,1-2.242-7.933Z",
    transform: "translate(1252.491 216.243)",
    fill: "#1a1311"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_39",
    "data-name": "\\uADF8\\uB8F9 39",
    transform: "translate(-1332.438 -319.222)",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_38",
    "data-name": "\\uADF8\\uB8F9 38",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_37",
    "data-name": "\\uADF8\\uB8F9 37"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_23",
    "data-name": "\\uD328\\uC2A4 23",
    d: "M-1237.62-234.579c-2.519-.858-5.263-5-10.673-4.9a11.143,11.143,0,0,1,7.328.065c1.361.5,2.011,1.6,3.636,2.747a13.171,13.171,0,0,0,5.641,2.372,12.038,12.038,0,0,1-5.932-.283",
    transform: "translate(1248.293 240.089)",
    fill: "#1a1311"
  }))))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_42",
    "data-name": "\\uADF8\\uB8F9 42",
    transform: "translate(-1338.907 -315.292)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_41",
    "data-name": "\\uADF8\\uB8F9 41",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_40",
    "data-name": "\\uADF8\\uB8F9 40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_24",
    "data-name": "\\uD328\\uC2A4 24",
    d: "M-1262.544-211.09a13.211,13.211,0,0,1-8.713-4.674,9.779,9.779,0,0,1-1.687-5.554,12.339,12.339,0,0,1,1.955-3.781c-1.715,11.667,8.111,14,8.445,14.008",
    transform: "translate(1272.975 225.098)",
    fill: "#fff"
  }))))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_45",
    "data-name": "\\uADF8\\uB8F9 45",
    transform: "translate(-1333.526 -314.593)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_44",
    "data-name": "\\uADF8\\uB8F9 44",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_43",
    "data-name": "\\uADF8\\uB8F9 43"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_25",
    "data-name": "\\uD328\\uC2A4 25",
    d: "M-1234.076-220.816s-7.442,5.863-18.369-.457a5.289,5.289,0,0,1,.138-1.158s8.857,6.4,18.231,1.615",
    transform: "translate(1252.445 222.431)",
    fill: "#fff"
  }))))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_26",
    "data-name": "\\uD328\\uC2A4 26",
    d: "M-1244.027-208.494a6.837,6.837,0,0,0,2.807,4.3c3.431,1.928,6.12,1.746,5.67.37a15.757,15.757,0,0,1-1.385-6.983s-4.518.465-7.682-1.984a17.99,17.99,0,0,0,.591,4.3",
    transform: "translate(-86.856 -99.274)",
    fill: "#c00020"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_48",
    "data-name": "\\uADF8\\uB8F9 48",
    transform: "translate(-1331.474 -312.067)",
    opacity: 0.25,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_47",
    "data-name": "\\uADF8\\uB8F9 47",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_46",
    "data-name": "\\uADF8\\uB8F9 46"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_27",
    "data-name": "\\uD328\\uC2A4 27",
    d: "M-1244.618-212.8c3.165,2.449,7.682,1.984,7.682,1.984q-.01.747.023,1.384c-1.964.608-5.8-.683-5.8-.683.111,4.615,3.983,6.811,4.743,7.2a11.728,11.728,0,0,1-3.246-1.289,6.829,6.829,0,0,1-2.809-4.3,17.95,17.95,0,0,1-.591-4.3",
    transform: "translate(1244.618 212.796)",
    fill: "#1a1311"
  }))))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_51",
    "data-name": "\\uADF8\\uB8F9 51",
    transform: "translate(-1322.855 -332.665)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_50",
    "data-name": "\\uADF8\\uB8F9 50",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_49",
    "data-name": "\\uADF8\\uB8F9 49"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_28",
    "data-name": "\\uD328\\uC2A4 28",
    d: "M-1211.741-291.369s5.385,1.765,4.874,7.045a9.9,9.9,0,0,1,3.278,1.423,21.657,21.657,0,0,0-2.822-7.579s-4.292-.846-5.329-.888",
    transform: "translate(1211.741 291.369)",
    fill: "#9c5706"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_54",
    "data-name": "\\uADF8\\uB8F9 54",
    transform: "translate(-1361.187 -335.835)",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_53",
    "data-name": "\\uADF8\\uB8F9 53",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_52",
    "data-name": "\\uADF8\\uB8F9 52"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_29",
    "data-name": "\\uD328\\uC2A4 29",
    d: "M-1313.541-299.558s-21-6.172-44.423,6.869c0,0,18.9-18.656,44.423-6.869",
    transform: "translate(1357.964 303.462)",
    fill: "#1a1311"
  }))))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_30",
    "data-name": "\\uD328\\uC2A4 30",
    d: "M-1292.78-345.5a2.244,2.244,0,0,1,1.911-1.741c1.72-.354,2.52.352,2.683.779a17.238,17.238,0,0,0-4.594.962",
    transform: "translate(-51.319)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_57",
    "data-name": "\\uADF8\\uB8F9 57",
    transform: "translate(-1344.099 -347.337)",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56",
    "data-name": "\\uADF8\\uB8F9 56",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_55",
    "data-name": "\\uADF8\\uB8F9 55"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_31",
    "data-name": "\\uD328\\uC2A4 31",
    d: "M-1292.78-345.5a2.244,2.244,0,0,1,1.911-1.741c1.72-.354,2.52.352,2.683.779a17.238,17.238,0,0,0-4.594.962",
    transform: "translate(1292.78 347.337)",
    fill: "#1a1311"
  }))))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_32",
    "data-name": "\\uD328\\uC2A4 32",
    d: "M-1291.868-344.749a1.789,1.789,0,0,1,1.522-1.388c1.37-.281,2.005.282,2.137.621a13.7,13.7,0,0,0-3.659.767",
    transform: "translate(-51.992 -0.829)",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33",
    "data-name": "\\uD328\\uC2A4 33",
    d: "M-1344.4-340.253l.006-.028c-1.2.347-1.915.624-1.915.624-15.516,5.925-15.012,20.462-15.012,20.462,1.413-1.175,5.968-4.195,5.968-4.195,2.4-13.874,10.953-16.864,10.953-16.864",
    transform: "translate(-0.747 -5.206)",
    fill: "#c00020"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34",
    "data-name": "\\uD328\\uC2A4 34",
    d: "M-1306.441-341.283c-6.506-6.215-16.889-4.093-21.146-2.858l0,.029s-8.557,2.988-10.953,16.862l4.551-3.17c22.883-8.642,35.8-.461,35.8-.461-.881-2.9-8.242-10.4-8.242-10.4",
    transform: "translate(-17.551 -1.346)",
    fill: "#126abf"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_60",
    "data-name": "\\uADF8\\uB8F9 60",
    transform: "translate(-1361.723 -342.831)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_59",
    "data-name": "\\uADF8\\uB8F9 59",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_58",
    "data-name": "\\uADF8\\uB8F9 58"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_35",
    "data-name": "\\uD328\\uC2A4 35",
    d: "M-1360.007-312.728a9.281,9.281,0,0,1,2.253-1.637,20.8,20.8,0,0,1,8.783-15.784s-9.529,4.348-11.036,17.422",
    transform: "translate(1360.007 330.15)",
    fill: "#fff"
  }))))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_63",
    "data-name": "\\uADF8\\uB8F9 63",
    transform: "translate(-1354.209 -344.805)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_62",
    "data-name": "\\uADF8\\uB8F9 62",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_61",
    "data-name": "\\uADF8\\uB8F9 61"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_36",
    "data-name": "\\uD328\\uC2A4 36",
    d: "M-1331.344-325.074s3.513-10.614,10.59-12.606a10.312,10.312,0,0,0-5.775,8.881,58.178,58.178,0,0,0-4.814,3.725",
    transform: "translate(1331.344 337.68)",
    fill: "#fff"
  }))))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_37",
    "data-name": "\\uD328\\uC2A4 37",
    d: "M-1264.822-331.928l.118-.011c.109-.009.217.008.262.133.058.158-.073.219-.235.233l-.112.012Zm-.318,1.165.426-.042-.048-.5.212-.019c.373-.037.624-.234.5-.562s-.463-.32-.789-.292l-.4.036Z",
    transform: "translate(-71.641 -11.18)",
    fill: "#c00020"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_38",
    "data-name": "\\uD328\\uC2A4 38",
    d: "M-1260.142-330.768l-.3.03.088-.417,0,0Zm-.744.5.341-.035.058-.236.453-.042.121.218.318-.029-.606-.989-.38.035Z",
    transform: "translate(-74.852 -11.776)",
    fill: "#00155e"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_39",
    "data-name": "\\uD328\\uC2A4 39",
    d: "M-1255.767-331.561a.667.667,0,0,0-.31-.035c-.3.026-.342.228-.262.415a.408.408,0,0,0,.437.237.551.551,0,0,0,.267-.085l.069.223a1.016,1.016,0,0,1-.293.073.751.751,0,0,1-.8-.424c-.139-.333.025-.588.446-.627a1.518,1.518,0,0,1,.421.017Z",
    transform: "translate(-77.937 -11.471)",
    fill: "#00155e"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_40",
    "data-name": "\\uD328\\uC2A4 40",
    d: "M-1252.428-331.984l.3-.027.255,1.016-.314.029Z",
    transform: "translate(-81.093 -11.307)",
    fill: "#00155e"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_41",
    "data-name": "\\uD328\\uC2A4 41",
    d: "M-1250.281-332.3l.745-.068.057.183-.457.042.058.218.443-.042.057.19-.442.042.115.422-.312.029Z",
    transform: "translate(-82.677 -11.047)",
    fill: "#00155e"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_42",
    "data-name": "\\uD328\\uC2A4 42",
    d: "M-1246.9-332.489l.3-.027.321,1-.31.03Z",
    transform: "translate(-85.175 -10.936)",
    fill: "#00155e"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_43",
    "data-name": "\\uD328\\uC2A4 43",
    d: "M-1243.885-332.628a.721.721,0,0,0-.314-.034c-.3.027-.309.224-.2.406a.466.466,0,0,0,.464.231.515.515,0,0,0,.256-.082l.1.22a1.021,1.021,0,0,1-.283.068.872.872,0,0,1-.851-.413c-.186-.326-.059-.574.354-.61a1.434,1.434,0,0,1,.419.013Z",
    transform: "translate(-86.725 -10.689)",
    fill: "#00155e"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_44",
    "data-name": "\\uD328\\uC2A4 44",
    d: "M-1263.15-325.616l.437-.043.186,1.6-.466.044Z",
    transform: "translate(-73.182 -15.995)",
    fill: "#c00020"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_45",
    "data-name": "\\uD328\\uC2A4 45",
    d: "M-1259.461-324.321a.735.735,0,0,0-.293-.026c-.13.013-.23.04-.2.135.062.168.524.057.664.419.13.337-.165.459-.463.489a1.583,1.583,0,0,1-.422-.024l-.006-.26a.772.772,0,0,0,.339.039c.1-.01.263-.048.219-.171-.073-.2-.539-.073-.656-.411-.107-.3.142-.414.411-.44a1.159,1.159,0,0,1,.393.015Z",
    transform: "translate(-75.284 -16.791)",
    fill: "#00155e"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_46",
    "data-name": "\\uD328\\uC2A4 46",
    d: "M-1254.547-325.292l-.406.038-.171.993-.51.052-.184-.959-.331.032.215,1.209.764-.077.116-.011.252-.027.036-.272.487-.048.156.253.339-.035Zm-.189.736.049-.479,0,0,.266.45Z",
    transform: "translate(-78.348 -16.266)",
    fill: "#00155e"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_47",
    "data-name": "\\uD328\\uC2A4 47",
    d: "M-1248.019-325.791l.4-.041.663.768h0l-.251-.807.3-.029.37,1.18-.416.043-.678-.789h0l.241.833-.32.03Z",
    transform: "translate(-84.346 -15.817)",
    fill: "#00155e"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_48",
    "data-name": "\\uD328\\uC2A4 48",
    d: "M-1242.33-325.936l.077-.009a.459.459,0,0,1,.5.218c.129.214.139.458-.184.488l-.145.015Zm-.011.988.537-.054c.467-.048.661-.294.366-.777a.859.859,0,0,0-.877-.386l-.411.039Z",
    transform: "translate(-88.252 -15.616)",
    fill: "#00155e"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_49",
    "data-name": "\\uD328\\uC2A4 49",
    d: "M-1236.858-326.486a.8.8,0,0,0-.294-.027c-.126.014-.218.039-.161.129.1.162.53.056.756.4.211.322-.05.439-.339.469a1.8,1.8,0,0,1-.423-.024l-.067-.247a.89.89,0,0,0,.34.034c.1-.01.252-.043.178-.164-.119-.187-.547-.069-.746-.391-.177-.287.037-.4.3-.423a1.261,1.261,0,0,1,.392.014Z",
    transform: "translate(-91.977 -15.2)",
    fill: "#00155e"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_50",
    "data-name": "\\uD328\\uC2A4 50",
    d: "M-1262.026-317.653a.924.924,0,0,0-.481-.062c-.477.046-.56.413-.452.766a.59.59,0,0,0,.663.449.838.838,0,0,0,.43-.161l.093.427a1.547,1.547,0,0,1-.476.131,1.089,1.089,0,0,1-1.217-.807.821.821,0,0,1,.769-1.144,1.928,1.928,0,0,1,.652.027Z",
    transform: "translate(-72.912 -21.596)",
    fill: "#c00020"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_51",
    "data-name": "\\uD328\\uC2A4 51",
    d: "M-1256.653-316.65l.36-.039.2,1.147.579-.062.056.3-.965.1Z",
    transform: "translate(-77.976 -22.613)",
    fill: "#00155e"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_52",
    "data-name": "\\uD328\\uC2A4 52",
    d: "M-1251.667-316.728c.11.458.154.81-.353.863a.646.646,0,0,1-.739-.4,1.285,1.285,0,0,1-.079-.273l-.132-.72.358-.035.163.8a1.492,1.492,0,0,0,.038.155.278.278,0,0,0,.282.189c.235-.026.146-.325.1-.556l-.136-.63.348-.035Z",
    transform: "translate(-80.693 -22.107)",
    fill: "#00155e"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_53",
    "data-name": "\\uD328\\uC2A4 53",
    d: "M-1246.965-317.456l.091-.012c.136-.016.229,0,.282.1s-.011.165-.159.182l-.136.013Zm-.054,1.2.625-.076c.309-.039.485-.21.334-.511a.452.452,0,0,0-.392-.243v0a.242.242,0,0,0,.177-.38.519.519,0,0,0-.522-.269l-.58.061Zm.2-.659.087-.01c.16-.017.253-.007.312.116s-.03.2-.212.224l-.1.011Z",
    transform: "translate(-84.819 -21.835)",
    fill: "#00155e"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_54",
    "data-name": "\\uD328\\uC2A4 54",
    d: "M-1278.284-319.55a2.355,2.355,0,0,0,1.429.316,1.968,1.968,0,0,0,1.238-.581Z",
    transform: "translate(-62.015 -20.306)",
    fill: "#00155e"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_55",
    "data-name": "\\uD328\\uC2A4 55",
    d: "M-1281.321-322.985l3.689-.361a1.673,1.673,0,0,0,.067-.369l-3.972.383a2.066,2.066,0,0,0,.216.347",
    transform: "translate(-59.615 -17.429)",
    fill: "#00155e"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_56",
    "data-name": "\\uD328\\uC2A4 56",
    d: "M-1276.821-321.848l-3.558.349a2.19,2.19,0,0,0,.385.343l2.945-.292a1.649,1.649,0,0,0,.229-.4",
    transform: "translate(-60.47 -18.807)",
    fill: "#00155e"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_57",
    "data-name": "\\uD328\\uC2A4 57",
    d: "M-1281.721-329.79a1.139,1.139,0,0,1,.393-1.039,1.666,1.666,0,0,0-.887,1.657,1.618,1.618,0,0,0,.124.486l1.341-.13v0c-.312-.124-.9-.446-.97-.972",
    transform: "translate(-59.106 -12.18)",
    fill: "#c00020"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_58",
    "data-name": "\\uD328\\uC2A4 58",
    d: "M-1275.127-330.279a2.27,2.27,0,0,0-2.367-1.517,2.126,2.126,0,0,0-.648.164h0c.3.155.792.408.96.521a.818.818,0,0,0,.028,1.411c-.309-.533-.359-.951.253-1.261a5.915,5.915,0,0,1,.626.336.718.718,0,0,0-.566,1v0l1.784-.171a1.7,1.7,0,0,0-.072-.485",
    transform: "translate(-62.12 -11.461)",
    fill: "#c00020"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_59",
    "data-name": "\\uD328\\uC2A4 59",
    d: "M-1279.475-329.136h0a.718.718,0,0,1,.565-1,6.253,6.253,0,0,0-.626-.336c-.613.31-.562.726-.253,1.26a.819.819,0,0,1-.028-1.411c-.167-.111-.658-.365-.961-.52a1.833,1.833,0,0,0-.173.083,1.143,1.143,0,0,0-.393,1.039c.07.525.659.847.972.973h0l-1.342.131c.014.033.03.071.046.1l3.972-.383c0-.037,0-.073,0-.11Z",
    transform: "translate(-59.484 -11.946)",
    fill: "#fff"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_60",
    "data-name": "\\uD328\\uC2A4 60",
    d: "M-1280.623-321.839l3.558-.35a1.018,1.018,0,0,0,.043-.12l-3.688.361c.028.039.057.074.087.109",
    transform: "translate(-60.225 -18.467)",
    fill: "#fff"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_61",
    "data-name": "\\uD328\\uC2A4 61",
    d: "M-1278.743-319.925l2.667-.266c.039-.041.076-.086.113-.133l-2.944.292a1.746,1.746,0,0,0,.163.106",
    transform: "translate(-61.556 -19.932)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_70",
    "data-name": "\\uADF8\\uB8F9 70",
    transform: "translate(-1344.052 -344.917)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_64",
    "data-name": "\\uADF8\\uB8F9 64",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_62",
    "data-name": "\\uD328\\uC2A4 62",
    d: "M-1274.905-330.349a.553.553,0,0,1-.6.816,39.1,39.1,0,0,0-7.254.023,43.2,43.2,0,0,0-7.7,1.427.807.807,0,0,1-1.005-.66c-.427-2.278-.8-4.287-1.127-6.071a.7.7,0,0,1,.607-.732,47.459,47.459,0,0,1,6.688-1.135,54.2,54.2,0,0,1,7.093-.221,1.131,1.131,0,0,1,.992.58C-1276.539-334.568-1275.775-332.592-1274.905-330.349Z",
    transform: "translate(1292.602 337.242)",
    fill: "#1a1311",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_63",
    "data-name": "\\uD328\\uC2A4 63",
    d: "M-1273.5-331.52a.553.553,0,0,1-.6.816,39.08,39.08,0,0,0-7.254.023,43.225,43.225,0,0,0-7.7,1.426.807.807,0,0,1-1.005-.66c-.426-2.278-.8-4.287-1.127-6.071a.7.7,0,0,1,.607-.732,47.428,47.428,0,0,1,6.688-1.135,54.087,54.087,0,0,1,7.092-.221,1.13,1.13,0,0,1,.991.58C-1275.135-335.739-1274.371-333.762-1273.5-331.52Z",
    transform: "translate(1291.565 338.106)",
    fill: "#fff"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_64",
    "data-name": "\\uD328\\uC2A4 64",
    d: "M-1267.546-332.114l.472-.052q0-.27,0-.533l.242-.025c.426-.046.744-.259.648-.615s-.491-.344-.871-.3l-.471.051Q-1267.542-332.875-1267.546-332.114Zm.481-1.26.136-.014c.125-.018.25,0,.285.14.041.168-.115.235-.3.257l-.129.013Q-1267.067-333.178-1267.064-333.374Z",
    transform: "translate(1274.114 334.827)",
    fill: "#c60014"
  }))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_65",
    "data-name": "\\uD328\\uC2A4 65",
    d: "M-1263.1-331.613l.387-.04.1-.25.523-.046.1.231.37-.024q-.264-.548-.52-1.07l-.451.037Q-1262.851-332.209-1263.1-331.613Zm.913-.544-.341.031q.083-.224.166-.444h0Q-1262.273-332.366-1262.187-332.157Z",
    transform: "translate(1270.833 334.199)",
    fill: "#002568"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_65",
    "data-name": "\\uADF8\\uB8F9 65",
    transform: "translate(9.101 1.285)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_66",
    "data-name": "\\uD328\\uC2A4 66",
    d: "M-1256.751-332.945a.8.8,0,0,0-.356-.05c-.361.023-.448.237-.385.442a.4.4,0,0,0,.453.265.712.712,0,0,0,.322-.082c.011.08.023.16.034.241a1.435,1.435,0,0,1-.354.063.725.725,0,0,1-.824-.464c-.105-.361.135-.64.641-.669a2.138,2.138,0,0,1,.491.024Q-1256.741-333.061-1256.751-332.945Z",
    transform: "translate(1257.886 333.203)",
    fill: "#002568"
  }))), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_67",
    "data-name": "\\uD328\\uC2A4 67",
    d: "M-1252.489-333.328l.363-.019q.02.537.047,1.1l-.374.018Q-1252.475-332.791-1252.489-333.328Z",
    transform: "translate(1263.004 334.594)",
    fill: "#002568"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_68",
    "data-name": "\\uD328\\uC2A4 68",
    d: "M-1249.883-333.473q.456-.018.917-.029c0,.065.006.132.009.2l-.555.019,0,.237.536-.016c0,.067.008.135.013.2l-.531.016q.01.225.02.455l-.367.015Q-1249.864-332.936-1249.883-333.473Z",
    transform: "translate(1261.082 334.709)",
    fill: "#002568"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_69",
    "data-name": "\\uD328\\uC2A4 69",
    d: "M-1245.729-333.547l.373-.006q.028.535.065,1.1l-.377.006Q-1245.7-333.012-1245.729-333.547Z",
    transform: "translate(1258.016 334.747)",
    fill: "#002568"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_66",
    "data-name": "\\uADF8\\uB8F9 66",
    transform: "translate(12.86 1.164)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_70",
    "data-name": "\\uD328\\uC2A4 70",
    d: "M-1242.371-333.388a.99.99,0,0,0-.374-.068c-.372,0-.452.21-.382.415a.46.46,0,0,0,.477.288.936.936,0,0,0,.337-.061c.014.079.027.159.041.24a1.77,1.77,0,0,1-.361.044.865.865,0,0,1-.885-.514c-.116-.361.123-.617.644-.622a1.808,1.808,0,0,1,.514.055C-1242.363-333.536-1242.367-333.462-1242.371-333.388Z",
    transform: "translate(1243.545 333.666)",
    fill: "#002568"
  }))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_71",
    "data-name": "\\uD328\\uC2A4 71",
    d: "M-1265.8-326.618l.486-.057q.008.8.029,1.661l-.489.059Q-1265.79-325.814-1265.8-326.618Z",
    transform: "translate(1272.824 329.672)",
    fill: "#c60014"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_67",
    "data-name": "\\uADF8\\uB8F9 67",
    transform: "translate(7.784 3.286)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_72",
    "data-name": "\\uD328\\uC2A4 72",
    d: "M-1261.99-325.3a.869.869,0,0,0-.314-.026c-.146.013-.258.043-.236.139.05.176.559.057.664.431.1.35-.235.473-.556.507a1.915,1.915,0,0,1-.444-.024c.007-.089.015-.177.022-.264a.786.786,0,0,0,.353.034c.114-.012.289-.045.255-.172-.053-.2-.563-.076-.652-.418-.081-.309.2-.434.5-.464a1.212,1.212,0,0,1,.435.015C-1261.971-325.463-1261.981-325.382-1261.99-325.3Z",
    transform: "translate(1262.91 325.57)",
    fill: "#002568"
  }))), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_73",
    "data-name": "\\uD328\\uC2A4 73",
    d: "M-1256.725-325.392q.075-.25.15-.5l.006,0,.2.477Zm.368-.755-.464.026q-.193.5-.379,1.019l-.558.04q-.024-.507-.043-.993l-.367.031q.021.609.05,1.25.412-.036.826-.066l.126-.006.282-.022q.042-.142.083-.282l.538-.03.121.27.382-.018Q-1256.064-325.555-1256.358-326.148Z",
    transform: "translate(1267.194 329.283)",
    fill: "#002568"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_74",
    "data-name": "\\uD328\\uC2A4 74",
    d: "M-1248.945-326.365l.46-.017q.273.407.552.83h0q-.038-.431-.071-.846l.357-.008q.043.605.1,1.241l-.473.007q-.285-.432-.563-.848l-.007,0q.035.428.075.87l-.357.012Q-1248.914-325.762-1248.945-326.365Z",
    transform: "translate(1260.389 329.473)",
    fill: "#002568"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_68",
    "data-name": "\\uADF8\\uB8F9 68",
    transform: "translate(6.713 3.038)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_75",
    "data-name": "\\uD328\\uC2A4 75",
    d: "M-1242.668-325.211l.62,0c.54-.005.839-.231.666-.752a.838.838,0,0,0-.891-.486l-.493,0Q-1242.722-325.845-1242.668-325.211Zm.3-1.005.095,0c.23-.005.426.04.5.266s.015.477-.358.482l-.172,0Q-1242.337-325.846-1242.366-326.216Z",
    transform: "translate(1249.117 326.47)",
    fill: "#002568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_76",
    "data-name": "\\uD328\\uC2A4 76",
    d: "M-1236.005-326.212a.84.84,0,0,0-.338-.061c-.158-.008-.273.014-.246.107.066.175.606.121.743.5.124.35-.22.435-.563.429a2.459,2.459,0,0,1-.471-.069q0-.129,0-.257a1.137,1.137,0,0,0,.379.072c.13.008.309-.015.261-.144-.068-.2-.606-.134-.725-.484-.109-.31.183-.4.5-.4a1.648,1.648,0,0,1,.461.066Q-1236-326.331-1236.005-326.212Z",
    transform: "translate(1244.852 326.516)",
    fill: "#002568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_77",
    "data-name": "\\uD328\\uC2A4 77",
    d: "M-1265.438-318.446a.945.945,0,0,0-.486-.058.569.569,0,0,0-.521.772.536.536,0,0,0,.632.429.928.928,0,0,0,.448-.162q.026.206.053.414a1.625,1.625,0,0,1-.484.133.993.993,0,0,1-1.161-.76.9.9,0,0,1,.87-1.166,2.066,2.066,0,0,1,.673.02Q-1265.427-318.637-1265.438-318.446Z",
    transform: "translate(1266.992 320.869)",
    fill: "#c60014"
  }))), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_78",
    "data-name": "\\uD328\\uC2A4 78",
    d: "M-1259.813-317.435l.377-.038q.029.554.065,1.134.3-.026.593-.049.009.142.019.287-.49.041-.977.092Q-1259.779-316.742-1259.813-317.435Z",
    transform: "translate(1268.408 322.882)",
    fill: "#002568"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_69",
    "data-name": "\\uADF8\\uB8F9 69",
    transform: "translate(1.556 1.446)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_79",
    "data-name": "\\uD328\\uC2A4 79",
    d: "M-1254.665-317.363c.038.456.024.8-.493.835a.592.592,0,0,1-.7-.408,1.161,1.161,0,0,1-.043-.277q-.018-.361-.033-.713l.373-.028q.024.391.052.794a.71.71,0,0,0,.02.154.241.241,0,0,0,.257.19c.242-.019.2-.313.183-.542q-.019-.318-.036-.628l.374-.023Q-1254.688-317.689-1254.665-317.363Z",
    transform: "translate(1263.989 321.831)",
    fill: "#002568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_80",
    "data-name": "\\uD328\\uC2A4 80",
    d: "M-1249.524-317.386l.091,0c.169-.009.265.006.306.131.04.141-.073.2-.267.2l-.1.007Q-1249.511-317.219-1249.524-317.386Zm-.325.632q.325-.024.651-.044c.329-.015.542-.171.454-.474a.4.4,0,0,0-.36-.263l-.006,0c.224-.03.332-.176.271-.366a.476.476,0,0,0-.5-.295q-.315.015-.628.034Q-1249.913-317.479-1249.849-316.753Zm.278-1.175.1-.006c.148,0,.249.012.279.12s-.049.161-.205.168l-.143.008Z",
    transform: "translate(1259.587 321.973)",
    fill: "#002568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_81",
    "data-name": "\\uD328\\uC2A4 81",
    d: "M-1282.1-319.87a2.528,2.528,0,0,0,1.486.19,2.343,2.343,0,0,0,1.3-.671Q-1280.706-320.146-1282.1-319.87Z",
    transform: "translate(1283.294 323.56)",
    fill: "#002568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_82",
    "data-name": "\\uD328\\uC2A4 82",
    d: "M-1285.457-323.412q1.957-.407,3.917-.674a1.661,1.661,0,0,0,.1-.385q-2.134.286-4.26.735a2.257,2.257,0,0,0,.247.323",
    transform: "translate(1285.956 326.6)",
    fill: "#002568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_83",
    "data-name": "\\uD328\\uC2A4 83",
    d: "M-1280.607-322.512q-1.885.262-3.764.652a2.284,2.284,0,0,0,.423.308q1.538-.312,3.079-.537a2.173,2.173,0,0,0,.262-.423",
    transform: "translate(1284.973 325.154)",
    fill: "#002568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_84",
    "data-name": "\\uD328\\uC2A4 84",
    d: "M-1286.131-329.937a1.258,1.258,0,0,1,.406-1.163h0a1.852,1.852,0,0,0-.915,1.876,1.791,1.791,0,0,0,.168.49q.717-.152,1.432-.284v0c-.335-.1-.983-.37-1.09-.916",
    transform: "translate(1286.667 331.491)",
    fill: "#c60014"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_85",
    "data-name": "\\uD328\\uC2A4 85",
    d: "M-1278.984-331.084a2.208,2.208,0,0,0-2.6-1.47,2.554,2.554,0,0,0-.741.24c.348.137.9.363,1.092.473-.265.227-.869.946.022,1.492-.336-.53-.4-.969.287-1.358a5.814,5.814,0,0,1,.69.317c-.321.085-.938.482-.638,1.1h0q.965-.16,1.933-.288a1.686,1.686,0,0,0-.048-.5",
    transform: "translate(1283.462 332.591)",
    fill: "#c60014"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_86",
    "data-name": "\\uD328\\uC2A4 86",
    d: "M-1283.527-329.513h0c-.3-.615.317-1.012.638-1.1a6.038,6.038,0,0,0-.687-.319c-.689.39-.63.83-.291,1.36-.891-.547-.286-1.266-.022-1.492-.192-.111-.744-.337-1.092-.473-.067.035-.133.072-.2.114a1.245,1.245,0,0,0-.4,1.162c.1.547.752.818,1.087.917q-.715.134-1.431.287l.058.107q2.128-.45,4.26-.735c0-.042.008-.081.012-.118Q-1282.562-329.674-1283.527-329.513Z",
    transform: "translate(1286.119 331.812)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_87",
    "data-name": "\\uD328\\uC2A4 87",
    d: "M-1284.661-322.223q1.881-.391,3.764-.652c.017-.042.037-.087.05-.129q-1.961.267-3.917.674Z",
    transform: "translate(1285.263 325.517)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_88",
    "data-name": "\\uD328\\uC2A4 88",
    d: "M-1282.583-320.274q1.39-.276,2.781-.481c.042-.044.084-.094.124-.144q-1.541.225-3.079.537c.054.031.116.06.173.088",
    transform: "translate(1283.781 323.964)",
    fill: "#fff"
  })))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_89",
    "data-name": "\\uD328\\uC2A4 89",
    d: "M-1338.594-307s-.8-1.248,7.217-6.831c9.7-5.732,29.337-3.987,29.337-3.987s11.559.813,9.711,4.455a14.956,14.956,0,0,1-6.2,3.4s-6.45-3.348-16.606-2.963a58.9,58.9,0,0,0-23.463,5.93",
    transform: "translate(-17.499 -21.598)",
    fill: "#126abf"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_73",
    "data-name": "\\uADF8\\uB8F9 73",
    transform: "translate(-1355.404 -339.321)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_72",
    "data-name": "\\uADF8\\uB8F9 72",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_71",
    "data-name": "\\uADF8\\uB8F9 71"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_90",
    "data-name": "\\uD328\\uC2A4 90",
    d: "M-1335.9-306.814s4.64-4.686,7.558-6.094c2.538-1.225,8.957-3.808,21.5-3.852,0,0-15.487.81-20.993,4.838a8.736,8.736,0,0,0-1.836,2.544,37.476,37.476,0,0,0-6.229,2.564",
    transform: "translate(1335.903 316.76)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_76",
    "data-name": "\\uADF8\\uB8F9 76",
    transform: "translate(-1337.268 -339.084)",
    opacity: 0.25,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_75",
    "data-name": "\\uADF8\\uB8F9 75",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_74",
    "data-name": "\\uADF8\\uB8F9 74"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_91",
    "data-name": "\\uD328\\uC2A4 91",
    d: "M-1250.515-315.857c4.221.721,6.015,1.94,4.717,2.886-2.433,1.774-3.672,1.369-8.084,1.015-3.57-.288-8.688-.574-12.839.771,1.5-.185,3.069-.319,4.683-.379,10.154-.386,16.406,2.876,16.406,2.876a13.834,13.834,0,0,0,5.982-3.288c.872-1.717-3.563-3.678-10.866-3.881",
    transform: "translate(1266.721 315.857)",
    fill: "#1a1311"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnTop);
export default __webpack_public_path__ + "static/media/btn-top.f139488f4b010934638f98b8e452086a.svg";
export { ForwardRef as ReactComponent };